import script from "./InsightContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsightContainer.vue?vue&type=script&setup=true&lang=ts"

import "./InsightContainer.vue?vue&type=style&index=0&id=44d9a663&lang=scss"

const __exports__ = script;

export default __exports__